// extracted by mini-css-extract-plugin
module.exports = {"deleteBtn":"DeleteDialog_deleteBtn__gIP6T"};